// extracted by mini-css-extract-plugin
export default {"arrow":"styles_arrow__s9InV","arrow__up":"styles_arrow__up__dBobR","arrow__down":"styles_arrow__down__Uam-V","arrow__disabled":"styles_arrow__disabled__VKW6S"};